/**
 * Unregister service workers, clear Cache Storage, then reload so the
 * user picks up a freshly deployed SPA (avoids stale SW cache-first assets).
 */
export async function hardRefresh() {
    try {
        if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            await Promise.all(registrations.map(registration => registration.unregister()));
        }
    } catch (_) {
        // ignore
    }

    try {
        if ('caches' in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map(key => caches.delete(key)));
        }
    } catch (_) {
        // ignore
    }

    window.location.reload();
}
